import { useCallback, useState } from "react";
import { Button, Checkbox, Input, Space } from "antd";
import Icon, { SearchOutlined } from '@ant-design/icons';
import Highlighter from 'react-highlight-words';
import { FaSearch } from 'react-icons/fa';

import { removeAcento } from '../../../../../../../utils/RemoveAcentos';

const IconSerach = (props: any) => <Icon {...props} component={FaSearch} ></Icon>

export const SEM_FONTES_KEY = '__SEM_FONTES__';

interface IProps {
    dataIndex?: string;
    getFontes?: (record: any) => any[] | undefined;
    valueFormatterBeforeCompare?: (value: string) => string;
    allowSemFontes?: boolean;
}

//Search da tabela de listagem
export const useFontesColumnSearchProps = ({
    dataIndex = "fontesConta",
    getFontes,
    valueFormatterBeforeCompare,
    allowSemFontes = true,
}: IProps = {}) => {
    const objProp = "numero";

    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');

    const handleSearch = useCallback((selectedKeys: any, confirm: any, dataIndex: any): void => {
        confirm();
        setSearchText(selectedKeys?.[0] || '');
        setSearchedColumn(dataIndex);
    }, []);

    const handleReset = useCallback((clearFilters: any): void => {
        clearFilters();
        setSearchText('');
    }, []);

    let searchInput: any = null;
    return ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }: any) => {
            const currentKey = selectedKeys?.[0];
            const isSemFontes = allowSemFontes && currentKey === SEM_FONTES_KEY;

            return (
                <div
                    style={{ padding: 8 }}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            e.stopPropagation();
                            handleSearch(selectedKeys, confirm, dataIndex);
                        }
                    }}
                >
                    <Input
                        ref={node => {
                            searchInput = node;
                        }}
                        placeholder={isSemFontes ? 'Filtro por contas sem fontes' : 'Digite...'}
                        value={isSemFontes ? '' : currentKey}
                        disabled={isSemFontes}
                        onChange={(e: any) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                        onPressEnter={(e) => {
                            e.stopPropagation();
                            handleSearch(selectedKeys, confirm, dataIndex);
                        }}
                        style={{ width: 200, marginBottom: 8, display: 'block' }}
                    />
                    {allowSemFontes && (
                        <div style={{ marginBottom: 8 }}>
                            <Checkbox
                                checked={isSemFontes}
                                onChange={(e) => {
                                    if (e.target.checked) {
                                        setSelectedKeys([SEM_FONTES_KEY]);
                                    } else {
                                        setSelectedKeys([]);
                                    }
                                }}
                            >
                                Sem fontes vinculadas
                            </Checkbox>
                        </div>
                    )}
                    <Space>
                        <Button
                            type="primary"
                            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                            icon={<SearchOutlined />}
                            size="small"
                            style={{ width: 95 }}
                        >
                            Pesquisar
                        </Button>
                        <Button
                            onClick={() => handleReset(clearFilters)}
                            size="small"
                            style={{ width: 95 }}
                        >
                            Limpar
                        </Button>
                    </Space>
                </div>
            );
        },
        filterIcon: (filtered: any) => filtered ? <IconSerach style={{ color: filtered ? '#1890ff' : undefined, fontSize: filtered ? 14 : undefined }} /> : <SearchOutlined />,
        onFilter: (value: any, record: any) => {
            const fontes = getFontes ? getFontes(record) : record?.[dataIndex];
            if (value === SEM_FONTES_KEY) {
                return !fontes || fontes.length === 0;
            }

            const valueToCompare = removeAcento(valueFormatterBeforeCompare ? valueFormatterBeforeCompare(value) : value);
            const fonteExists = fontes?.some((e: any) => {
                const numero = e?.numero || e?.fonte?.[objProp];
                return numero ? String(numero).includes(valueToCompare) : false;
            });

            return !!fonteExists;
        },
        onFilterDropdownVisibleChange: (visible: any) => {
            if (visible) {
                setTimeout(() => {
                    if (searchInput && typeof searchInput.select === 'function') {
                        searchInput.select();
                    }
                });
            }
        },
        render: (text: any) =>
            searchedColumn === dataIndex && searchText !== SEM_FONTES_KEY ? (
                <Highlighter
                    highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                    searchWords={[searchText]}
                    autoEscape
                    textToHighlight={text ? text.toString() : ''}
                />
            ) : (
                text
            ),
    });
};
